<template>
  <div slot-scope="{ activate }">
    <modal
      ref="modal"
      variant="default"
      no-footer
      is-alert-dialog
      class="modify-modal modify-modal__logout"
      aria-labelled-by="modify-logout-modal-title"
      @input="handleOpenModal"
      @close="handleCloseModal"
    >
      <template #default="{ activate }">
        <slot v-bind="{ activate }" />
      </template>
      <template #header>
        <div
          id="modify-logout-modal-title"
          class="title"
        >
          {{ ModifyReservationPopupSessionTitle }}
        </div>
      </template>
      <template #body="{ deactivate }">
        <div class="description">
          {{ ModifyReservationPopupSessionSubTitle }}
        </div>
        <div class="button-wrapper">
          <button
            class="button extend-session"
            @click="extendSession(deactivate)"
            @keydown.space.prevent="extendSession(deactivate)"
            @keydown.enter.prevent="extendSession(deactivate)"
          >
            {{ ModifyReservationPopupSessionCTALabel }}
          </button>
          <button
            class="button end-session"
            @click="closeSession(deactivate)"
            @keydown.space.prevent="closeSession(deactivate)"
            @keydown.enter.prevent="closeSession(deactivate)"
          >
            {{ ModifyReservationPopupEndSessionCTALabel }}
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

  <script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    name: 'ModifyLogoutModal',
    data: () => ({
      shouldRedirect: true,
    }),
    computed: {
      ...mapState('global', { currentLanguage: 'lang' }),
      ...mapState('modifyReservation', ['modifyBookingPropData', 'showSessionEndPopUp']),
      ...mapGetters('auth', ['haveProfileData']),
      ModifyReservationPopupSessionTitle() {
        return this.modifyBookingPropData?.ModifyReservationPopupSessionTitle ? this.modifyBookingPropData.ModifyReservationPopupSessionTitle : ''
      },
      ModifyReservationPopupSessionSubTitle() {
        return this.modifyBookingPropData?.ModifyReservationPopupSessionSubTitle ? this.modifyBookingPropData.ModifyReservationPopupSessionSubTitle : ''
      },
      ModifyReservationPopupSessionCTALabel() {
        return this.modifyBookingPropData?.ModifyReservationPopupSessionCTALabel || ''
      },
      ModifyReservationPopupEndSessionCTALabel() {
        return this.modifyBookingPropData?.ModifyReservationPopupEndSessionCTALabel || ''
      },
      ModifyReservationLookupPageUrl() {
        return this.modifyBookingPropData?.ModifyReservationLookupPageUrl ? this.modifyBookingPropData.ModifyReservationLookupPageUrl : ''
      },
      ModifyReservationDetailPageUrl() {
        return this.modifyBookingPropData?.ModifyReservationDetailPageUrl ? this.modifyBookingPropData.ModifyReservationDetailPageUrl : ''
      }
    },
    watch: {
      showSessionEndPopUp(val) {
        if (val) {
          this.$refs.modal.activate(this)
        }
      }
    },
    methods: {
      ...mapActions('modifyReservation', ['continueSession', 'endSession']),
      handleCloseModal() {
        document.body.classList.remove('no-scroll')
        if (this.shouldRedirect) {
          if (!this.haveProfileData) {
            if (this.ModifyReservationLookupPageUrl !== '') {
              window.location.href = `/${this.currentLanguage}/${this.ModifyReservationLookupPageUrl}`
            } else {
              window.location.href = '/'
            }
          } else if (this.ModifyReservationDetailPageUrl !== '') {
            window.location.href = `/${this.currentLanguage}/${this.ModifyReservationDetailPageUrl}`
          } else {
            window.location.href = '/'
          }
        }
      },
      extendSession(deactivate) {
        this.shouldRedirect = false
        this.continueSession()
        deactivate()
      },
      closeSession(deactivate) {
        this.shouldRedirect = true
        this.endSession()
        deactivate()
      },
      handleOpenModal() {
        document.body.classList.add('no-scroll')
        this.$emit('activate')
      },
    }
  }
  </script>
